import { RouteType } from "types/RouteType";
import { routesWithAuth } from "../stores/RouterStore/authRoutes";
import adminRoutesList from "./admin/adminRoutesList";
import accountingRoutesList from "./accounting/accountingRoutesList";
import crmRoutesList from "./crm/crmRoutesList";
import productRoutesList from "./product/productRoutesList";
import dispatchRoutesList from "./dispatch/dispatchRoutesList";
import batchPlantRoutesList from "./batchPlant/batchPlantRoutesList";
import operationsRoutesList from "./operations/operationsRoutesList";
import schedulingRoutesList from "./scheduling/schedulingRoutesList";
import qualityControlRoutesList from "./qualityControl/qualityControlRoutesList";
import inventoryAndFieldRoutesList from "./inventoryAndField/inventoryAndFieldRoutesList";
import projectManagementRoutesList from "./projectManagement/projectManagementRoutesList";
import administrationRoutesList from "./administration/administrationRoutesList";
import settingsRoutesList from "./settings/settingsRoutesList";
import estimatingRoutesList from "./estimating/estimatingRoutesList";
import purchasingRoutesList from "./purchasing/purchasingRoutesList";
import QuoteToDeliveryRoute from "./purchasing/quote-to-delivery/QuoteToDelivery.Route";
import MixDesignImportRoute from "./purchasing/mix-design-import/MixDesignImport.Route";
import MaterialsRoute from "./materials/Materials.Route";
import fieldReportingRoutesList from "./fieldReporting/fieldReportingRoutesList";
import workflowsRoutesList from "./workflows/workflowsRoutesList";
import PdfEditorRoute from "./pdf/editor/PdfEditor.Route";
import PdfManagementRoute from "./pdf/management/PdfManagement.Route";
import OrdersListRoute from "./orders/OrdersList/OrdersList.Route";
import { generateServiceViewRoutes } from "../stores/RouterStore/utils/ServiceViewRouteGenerator";
import serviceStores from "../serviceStoresConfig";

// Generate dynamic service view routes
const serviceViewRoutes = generateServiceViewRoutes(serviceStores);

const routesList: RouteType[] = [
  ...routesWithAuth,
  ...adminRoutesList,
  ...accountingRoutesList,
  ...crmRoutesList,
  ...productRoutesList,
  ...dispatchRoutesList,
  ...batchPlantRoutesList, // Renamed from production - batch plant operations for ReadyMix
  ...operationsRoutesList,
  ...schedulingRoutesList,
  ...qualityControlRoutesList,
  ...inventoryAndFieldRoutesList, // Updated to focus on raw materials only
  ...projectManagementRoutesList, // Updated for commercial/large residential projects
  ...administrationRoutesList,
  ...settingsRoutesList,
  ...estimatingRoutesList,
  ...purchasingRoutesList,
  QuoteToDeliveryRoute, // Updated from QuoteToProduction for ReadyMix delivery workflow
  MixDesignImportRoute, // Updated from BomImport - simplified to mix designs
  MaterialsRoute,
  ...fieldReportingRoutesList,
  ...workflowsRoutesList,
  PdfManagementRoute,
  PdfEditorRoute,
  OrdersListRoute,
  ...serviceViewRoutes, // Add generated service view routes
];

export default routesList;
